import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router'
import '../styling/containerStyles.css'
import VerifyNumber from './verifyNumber'
import VerifyOtp from './verifyOtp';
import VerifyOtpDealer from './verifyOtpDealer';
import CustomerDetails from './customerDetails'
import TransactionDetails from './transactionDetails'
import BankDetails from './bankDetails'
import OnfidoPage from './onfidoPage'
import Success from './successTransaction'
import Footer from '../components/footer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Payouts from '../container/paytmPayout'
import PreviousBankDetails from '../container/previousBankDetails';
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ErrorMessage from './errorMessage';
import HaishaBonus from './haishaBonus';
import { Typography } from '@material-ui/core';
import ImageUploadPage from './imageUpload';
import OnfidoPageptr from './onfidoPageptr';

interface MainProps{
  [x: string]: any;
  newCoupon?:string;
}


var Onfido = require('onfido-sdk-ui/dist/onfidoAuth.min.js')


export const Main: React.FC<MainProps> = (props: MainProps) =>{
// export const Main: React.FC = () =>{

    const [phoneNo, setPhoneNo] = useState('')
    const [phoneNodealer, setPhoneNodealer] = useState('')
    const [isDealerVerifed, setisDealerVerifed] = useState(false);
    const [codeScanStatus, setCodeScanStatus] = useState(true)
    const [codeScanStatusCode, setCodeScanStatusCode] = useState('')
    const [isVerified, setIsVerified] = useState(false) 
    const [isOtpVerified, setIsOtpVerified] = useState(false)
    const [isNewUser, setIsNewUser] = useState(true) 
    const [newUser, setNewUser] = useState(true) 
    const [isProceeded, setIsProceeded] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState('')
    const [bonusAmount, setBonusAmount] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [paymentStatus, setPaymentStatus] = useState('')
    const [accNo, setAccNo] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [bankDetailsSet, setBankDetailsSet] = useState(false)
    const [membershipID, setMembershipID] = useState('')
    const [redeemable, setRedeemable] = useState(false)
    const [paymentMessage, setPaymentMessage] = useState('')
    const [msgPh, setMsgPh] = useState('')
    const [bankMsg, setBankMsg] = useState('')
    const [transactions, setTransactions] = useState('')
    const [conversions, setConversions] = useState(['', '', ''])
    const [confirmedPayStatus, setConfirmedPayStatus] = useState(false)
    const [orderID, setOrderID] = useState('')
    const [razorID, setRazorID] = useState('')
    const [canRedeem, setCanRedeem] = useState(true)
    const [couponValid, setInvalidCoupon] = useState(false)
    const [otpMessage, setOtpMessage] = useState('')
    const [failUnbind, setFailUnbind] = useState('')
    const [transactionLoading, setTransactionLoading] = useState(false)
    const [transactionsAmmount, setTransactionsAmmount] = useState('')
    const [countCheck, setCount] = useState(true)
    const [previousBankDetails, setPreviousBankDetails] = useState('')
    const [previousBankDetailsFlag, setPreviousBankDetailsFlag] = useState(false)
    const [prevBankType, setPreviousBankType] = useState(false)
    const [prevBankUUID, setPreviousBankUUID] = useState(['', ''])
    const [loadingRedeem, setLoadingRedeem] = useState(false)
    const [bonusPoint, setBonusPoint] = useState(['', '', ''])
    const [isOnfidoPage, setIsOnfidoPage] = useState(false)
    const [SDKToken, setSDKToken] = useState('');
    const [KycStatus, setKycStatus] = useState('');
    const [KycStatusAttempt, setKycStatusAttempt] = useState(0);
    const [LoginMsg, setLoginMsg] = useState(false);
    const [RejectKYC, setRejectKYC] = useState(false);
    const [KYCRequired, setKYCRequired] = useState(false);
    const [userType, setuserType] = useState('BST');
    const [specialBonus, setSpecialBonus] = useState('');
    const [showTranDet, setShowTranDet] = useState(false);

    // Added for IDFY
    const [getFile, setGetFile] = useState('');
    const [docUploadFlag, setDocUploadFlag] = useState('');
    const [idfyDocData, setIdfyDocData] = useState('');
    const [skipStatus, setSkipStatus] = useState('');
    const [idfyTranStatus, setIdfyTranStatus] = useState('');
    const [docUploadLoading, setDocUploadLoading] = useState(false);
    const [idfyCountCheck, setIdfyCount] = useState(true);
    const [kycMessageVerified, setKycMessageVerified] = useState('');
    const [kycDocStatus, setKycDocStatus] = useState('');
    const [isSelfiePage, setIsSelfiePage] = useState(false);
    const [getSelfie, setSelfieFile] = useState('');
    const [selfieDocStatus, setSelfieDocStatus] = useState('');
    const [faceLiveMessage, setFaceLiveMessage] = useState('')
    // end here

    // Added for Enamel Category
    const [enamelCategory, setEnamelCategory] = useState('');
    // end here

    const HOST = process.env.REACT_APP_HOST; 
    const API = process.env.REACT_APP_API;

    // Function to dynamically construct URL with correct path
    const constructDynamicURL = (targetPath: string) => {
      const currentPath = window.location.pathname;
      const pathSegments = currentPath.split('/');
      
      // Replace only the first segment (PC/PTR) with the target path
      pathSegments[1] = targetPath;
      
      // Reconstruct the full URL
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port;
      const baseURL = `${protocol}//${hostname}${port ? ':' + port : ''}`;
      
      return `${baseURL}${pathSegments.join('/')}`;
    };

    var onfidoTag: any;
    let interval : any;
    let interval1: any;

    const path = window.location.pathname; //using only for roofsealclassic
    const pathParams = path.split('/') //using only for roofsealclassic
    const isDashboardFlag = props.isDashboard

    const refresh_error_msg = 'Token is invalid or expired';
    let count = 0; 
    
    let hostName = window.location.hostname.split('.')[0]

    if(hostName === 'localhost'){
      hostName = 'hccinstantrewards'
    }
  
    interface ParamTypes {
      couponId: string,
      projecttype: string,
    }

    const couponCode = useParams<ParamTypes>().couponId

    const projecttype = useParams<ParamTypes>().projecttype


    const newCouponCode = props.newCoupon //using only for roofsealclassic
    
    const axios = require('axios').default;

    const resetAll = (couponUnbind: boolean) => {
        
        setIsOtpVerified(false)
        setIsVerified(false)
        setIsProceeded(false)
        setIsSuccess(false)
        setIsNewUser(true)
    }

    const resetWhileLogoutAll = (couponUnbind: boolean) => {
      setIsOtpVerified(true)
      setIsProceeded(false)
  }

  

    useEffect(() => {
      (async () => {
        if(!isDealerVerifed && !props.dealer_sso ){
          await checkCode();
          let enamelCategory = '';
          if (localStorage.getItem("IS_LOGIN") === "yes" && pathParams[2].toLowerCase() === 'puenml') {
            localStorage.removeItem("haisha_enamel_category");
            const phoneNumberForEnamel = localStorage.getItem("phone_number");
            if (phoneNumberForEnamel) {
              const enamelCategoryResponse = await getEnamelCategory(phoneNumberForEnamel)
              enamelCategory = enamelCategoryResponse.data.endusercategory;
              setEnamelCategory(enamelCategory);
              localStorage.setItem("haisha_enamel_category", enamelCategory);
              await handleToUpdateOTP("");

              if(pathParams[2].toLowerCase() === 'puenml' && !props.dealer_sso) {
                if(enamelCategory && enamelCategory === "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'pc'){
                  window.location.replace(constructDynamicURL('PC'))
                } else if(enamelCategory && enamelCategory !== "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'ptr') {
                  window.location.replace(constructDynamicURL('PTR'))
                }
              }
            }
          } else {
            localStorage.removeItem("haisha_enamel_category");
          }
        }
        if(localStorage.getItem("IS_LOGIN") === "yes") {
          resetWhileLogoutAll(true);
        }
      })();

      // The below code added before the haisha enamel development
    // } 
    //   if(!isDealerVerifed && !props.dealer_sso ){
    //     checkCode();
    //   }
    //   if(localStorage.getItem("IS_LOGIN") === "yes") {
    //     resetWhileLogoutAll(true);
    //   }
    

    }, [])

 
    useEffect(() => {
      // setLoading(true);
        if(membershipID && pathParams[1].toLowerCase() == 'pc'&& !props.dealer_sso){
          //   interval1 = setInterval(() => {
          //     checkSKDToken();
          //  }, 1000);
          //  getOnfidoStatus1();
           
           if(localStorage.getItem('x-access-token')){
            //  checKYCStatus();
           }    
        }
  }, [membershipID])


  useEffect(() => {
    console.log(props.dealer_sso ,!localStorage.getItem("isDealerVerified"));
    if (props.dealer_sso && !localStorage.getItem("isDealerVerified")) {
      handleToUpdateNumberDealer(props.dealer_sso);
      setisDealerVerifed(true);
      setIsVerified(true);
    }else {
      if(props.dealer_sso && (pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc')){
        checkCode();
      }else{
        setLoading(false);
        if(localStorage.getItem("phone_number") && localStorage.getItem("isDealerVerified") == "yes" ){
          
          // redemption();
          handleToUpdateStatusDealer();
          handleToUpdateAmount();
        }
      }
    }
  }, [props.dealer_sso])

  console.log(!isVerified , !loading , paymentStatus !== 'AMOUNTINVALID' , paymentStatus !== 'MEMBERINVALID' , paymentStatus !== 'BLOCKUSER' , paymentStatus !== 'RESPONSE_MESSAGE' , !isDealerVerifed ,
  !localStorage.getItem("IS_LOGIN") , !isDashboardFlag );


  const checkSKDToken = async () => {
    setLoading(true)
    return axios
      .get(
        `${HOST}apis/v.1.0/onfido/get-sdk-token/?membership_no=${membershipID}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-application-token':'8a16f58c77d04ff49ad9998aba16462258add7ea__token__eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbmFtZSI6InBpbGxsaWxiZWprbGV0a2Vwcm9kIiwidHlwZSI6ImZyb250d2Vwcm9kIn0.Pp5DUQJxYIzuL7IexPDf-EGutokUbl8mZrK_o5rvfCA'
          }
        }
      )
      .then((res: any) => {
        setSDKToken(res.data.sdk_token);
        clearInterval(interval1);
        setLoading(false);
        return res;
      })
  }


  const checKYCStatus = async () => {
    setLoading(true)
    return axios
      .get(
        `${HOST}apis/v.1.0/haisha-contractor/${localStorage.getItem("phone_number")}/check-kyc-required/`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then((res: any) => {
        const data = res.data;
        setLoading(false)
        if(pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc') {
          setSkipStatus(data.is_kyc_required)
          setIsOnfidoPage(true);
        } else {
          setKYCRequired(res.data.is_kyc_required);
        }
        return res;
      })
      .catch((error: any) => {
        setLoading(false)
        return error
      });
  }


    const checkCode = async() => {
      setLoading(true)
      return axios
      .post(
        localStorage.getItem("isDealerVerified") === "yes" ?
        `${HOST}${API}haisha-dealer-validate-coupon-code/` : `${HOST}${API}check-coupon-code/` ,
        {
          code: pathParams[3],
          user: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data = res.data.data
        if(data.resultCode === 0){
          setAmount(data.codePoint)
          if(localStorage.getItem("IS_LOGIN") === "yes") {
            if (pathParams[2].toLowerCase() !== 'puenml' || props.dealer_sso) {
              handleToUpdateOTP("");
            }
          }
        }
        else{
          setCodeScanStatusCode(data.resultCode)
          setInvalidCoupon(true)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
        }
        setLoading(false)
        return data;
      })
      .catch((err: any) => {
        const amtInvalid = err.response.data;
        if(amtInvalid.amount_invalid === true) {
          handleToUpdateStatus('AMOUNTINVALID', amtInvalid.message, '-', '-')
        }
        if(amtInvalid.user_blocked === true) {
          handleToUpdateStatus('BLOCKUSER', amtInvalid.message, '-', '-')
        }
          setCodeScanStatusCode(amtInvalid.resultCode)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
          setLoading(false)
          return err;
      });
    }

  const getEnamelCategory = async (arg: any) => {
    setLoading(true)
    return axios
      .get(
        `${HOST}${API}check-enduser-category/?phone_number=${arg}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then((res: any) => {
        setLoading(false)
        return res;
      })
  }

    const getOtp = async (arg: any, enamelCategory: any) => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}login/hccinstantrewards/login-get-otp/`,
        {
          phone_number: arg, 
          app_name: 'paytm', 
          paytm_user_type: "BST",
          endusercategory_c: pathParams[2].toLowerCase() === "puenml" && !props.dealer_sso ? enamelCategory :
          pathParams[1].toLowerCase() == 'pc' ? "PAINTING CONTRACTORS" : "Painters"
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        setLoading(false)
        return res;
      })
      .catch((err: any) => {
          setLoading(false)
          setLoginMsg(true);
          return err;
      });
    }

    const getOtpDealer = async (arg: any) => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}login/hccinstantrewards/login-get-otp/`,
        {
          phone_number: arg, 
          app_name: 'paytm', 
          paytm_user_type: "BST",
          endusercategory_c: pathParams[1].toLowerCase() == 'pc' ? "PAINTING CONTRACTORS" : "Painters",
          user_type: "dealer"
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        setLoading(false)
        return res;
      })
      .catch((err: any) => {
          setLoading(false)
          setLoginMsg(true);
          return err;
      });
    }


  const handleToUpdateNumberDealer = async (arg: any) => {
    if(pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc'){
      if (codeScanStatus === true) {
        setPhoneNodealer(arg)
        try {
          const checkCodeResponse = await checkCode()
          if (checkCodeResponse.resultCode === 0) {
            setAmount(checkCodeResponse.codePoint)
            if (localStorage.getItem("IS_LOGIN") === "yes") {
              // resetWhileLogoutAll(true);
              // redemption();
              handleToUpdateOTP("");
            }
            const fetchResponse = await getOtpDealer(arg);
            if (fetchResponse.status === 200) {
              localStorage.setItem('phone_number', arg)
              setIsVerified(true)
            }
            else {
              setMsgPh('Something went wrong')
            }
          }
          else {
            setCodeScanStatusCode(checkCodeResponse.resultCode)
            setInvalidCoupon(true)
            setCodeScanStatus(false)
            setIsOtpVerified(false)
            setIsVerified(false)
          }
        }
        catch (e) {
          setMsgPh('Something went wrong')
        }
      }
    }else {
      setPhoneNodealer(arg)
      if (localStorage.getItem("IS_LOGIN") === "yes") {
        // resetWhileLogoutAll(true);
        // redemption();
        handleToUpdateOTP("");
      }
      const fetchResponse = await getOtpDealer(arg);
      if (fetchResponse.status === 200) {
        localStorage.setItem('phone_number', arg)
        setIsVerified(true)
      }
      else {
        setMsgPh('Something went wrong')
      }
    }
   
  }

    const handleToUpdateNumber= async (arg: any) => {
      if(pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc'){
      if(codeScanStatus === true   ){
        setPhoneNo(arg)
          try {
            const checkCodeResponse = await checkCode()                 
            if(checkCodeResponse.resultCode === 0){
              setAmount(checkCodeResponse.codePoint)
              if(localStorage.getItem("IS_LOGIN") === "yes") {
                // resetWhileLogoutAll(true);
                // redemption();
                handleToUpdateOTP("");
              }

              let enamelCategory = '';
              if (pathParams[2].toLowerCase() === 'puenml' && !props.dealer_sso) {
                const enamelCategoryResponse = await getEnamelCategory(arg)
                enamelCategory = enamelCategoryResponse.data.endusercategory;
                setEnamelCategory(enamelCategory);
              }
              const fetchResponse = await getOtp(arg, enamelCategory);
              if(fetchResponse.status === 200){
                if(localStorage.getItem("isDealerVerified") === "yes"){
                  localStorage.setItem('contractor_phone_number', arg)
                }else {
                  localStorage.setItem('phone_number', arg)
                }
                setIsVerified(true)
              }
              else{
                setMsgPh('Something went wrong')
              }
            }
            else{
              setCodeScanStatusCode(checkCodeResponse.resultCode)
              setInvalidCoupon(true)
              setCodeScanStatus(false)
              setIsOtpVerified(false)
              setIsVerified(false)
            }
            
          } catch (e) {
            setMsgPh('Something went wrong')
          }
        }       
      }else {
        setPhoneNo(arg)
        if(localStorage.getItem("IS_LOGIN") === "yes") {
          // resetWhileLogoutAll(true);
          // redemption();
          handleToUpdateOTP("");
        }
        
        let enamelCategory = '';
        if (pathParams[2].toLowerCase() === 'puenml' && !props.dealer_sso) {
          const enamelCategoryResponse = await getEnamelCategory(arg)
          enamelCategory = enamelCategoryResponse.data.endusercategory;
          setEnamelCategory(enamelCategory);
        }
        
        const fetchResponse = await getOtp(arg, enamelCategory);
        if(fetchResponse.status === 200){
          if(localStorage.getItem("isDealerVerified") === "yes"){
            localStorage.setItem('contractor_phone_number', arg)
          }else {
            localStorage.setItem('phone_number', arg)
          }
          setIsVerified(true)
        }
      }
    }
    
  const getTokenPair = (phoneNumber: any, otp: any) => {
    setLoading(true)
    return axios
      .post(
        `${HOST}${API}login/token-access/`,
        {
          phone_number: phoneNumber,
          otp: otp,
          app_name: 'paytm'
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        if (!isDealerVerifed) {
          setLoading(false)
          localStorage.setItem('IS_LOGIN', "yes")
        } else {
          if (
            (pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc'
            )) {
            setLoading(false)
          } else {
            setTimeout(() => {
              setLoading(false)
              if (localStorage.getItem('x-access-token')) {
                handleToUpdateStatusDealer();
              }
            }, 200);
          }
        }
        return res;
      })
      .catch((err: any) => {
        return err;
      });
  };

    const redemption = async() =>{
      setLoading(true)
      setLoadingRedeem(true)
      const enamel_category = localStorage.getItem("haisha_enamel_category") ? localStorage.getItem("haisha_enamel_category") : '';
      return axios
        .post(
        localStorage.getItem("isDealerVerified") === "yes" ?
         `${HOST}${API}haisha-dealer-validate-redeemability/` : `${HOST}${API}check-redeemability/` ,
        {
          phone_number: localStorage.getItem("IS_LOGIN") === "yes" ?
          localStorage.getItem("isDealerVerified") === "yes" ?
            localStorage.getItem("contractor_phone_number")
            : localStorage.getItem("phone_number") : phoneNo,
          division: "BST",
          product: pathParams[2],
          code: pathParams[3],
          persona: pathParams[2].toLowerCase() === "puenml" && !props.dealer_sso ? enamel_category == 'PAINTING CONTRACTORS' ? 'pc' : 'ptr' : 
          pathParams[1].toLowerCase()
        },
        {
          headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('x-access-token')
          }
        }
        )
        .then((res: any) => {
        setLoading(false)
        setLoadingRedeem(false)
        if(res.data.data.endusercategory_c){
          localStorage.setItem("isEndUserCategory", res.data.data.endusercategory_c);
          localStorage.setItem("division", res.data.data.division == "CC" || 
          res.data.data.division == "EI" ? "CWC" : "BST");
        }
        setuserType(res.data.data.division == "CC" || 
        res.data.data.division == "EI" ? "CWC" : "BST");
          // userType =  
          // alert(userType);        
          return res;
        })
        .catch((err: any) => {
        const memberValidation = err.response.data;
        if(memberValidation.user_can_order === true) {
          handleToUpdateStatus('MEMBERINVALID', memberValidation.message, '-', '-');
        }
        setLoading(false)
        setLoadingRedeem(false)
        return err;
        });
    }

    const refresh_access_token = async (res: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-refresh/`, 
            {
              refresh: localStorage.getItem('x-refresh-token')
            },
            {
              headers: {
                'Content-Type': 'application/json',       
              }
            }
          )
          .then((res: any) => {
              if(res.status === 200){
                localStorage.setItem('x-access-token', 'Token ' + res.data['access'])
              }
              else{
                setMsgPh('something went wrong')
                setIsVerified(false)
              }
            })
          .catch((err: any) => {
            setMsgPh('something went wrong')
            setIsVerified(false)
          });
    }

    const handleToUpdateOTP = async (arg: any) => {
      const enamel_category = localStorage.getItem("haisha_enamel_category") ? localStorage.getItem("haisha_enamel_category") : '';
      setEnamelCategory(enamel_category || '');
        if(arg === 'GoBack'){
            setIsVerified(false)
        }
        else {
          if(!localStorage.getItem("IS_LOGIN")){
            setLoading(true)
          
          
          if(newUser === false){
            setIsNewUser(false)
          }
        }          
          try {
            if(localStorage.getItem("IS_LOGIN") === "yes") {
              if(pathParams[2].toLowerCase() === 'puenml' && !props.dealer_sso) {
                if(enamelCategory && enamelCategory === "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'pc'){
                  window.location.replace(constructDynamicURL('PC'))
                } else if(enamelCategory && enamelCategory !== "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'ptr') {
                  window.location.replace(constructDynamicURL('PTR'))
                }
              }
              const redemptionResponse = await redemption() 
                
              const response = redemptionResponse.data.data
              if(response.redeemable === false){
                setPaymentStatus('NOT POSSIBLE')
                setPaymentMessage("You are a " + response.user_type)
                setIsSuccess(true)
                setCanRedeem(false)
              }
              else{
                setIsOtpVerified(true)
                if(response.user_type !== "NEW USER"){
                  setIsNewUser(false)
                  setNewUser(false)
                  setMembershipID(response.membership_id)
                  if (pathParams[2].toLowerCase() !== 'dfwpputty' && (response.membership_id && pathParams[1].toLowerCase() == 'pc' && !props.dealer_sso)) {
                    await checkSpecialBonus(response.membership_id)
                  }
                }

                if(response.redemption_options.POINTS === true){
                  setRedeemable(true)
                }
                const factor = response.conversion
                const bonusFactor = response.bonus
                setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
              }

            }
            else {
            const fetchResponse = await getTokenPair(phoneNo, arg)
            const status = fetchResponse.status
            if(status === 200){
                const headers = fetchResponse.headers
                localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
                localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])

                // Only replace URL if enamelCategory is "PAINTING CONTRACTORS" and pathParams[1] is not 'pc'
                // Only replace URL if pathParams[2] is 'puenml'
                if(pathParams[2].toLowerCase() === 'puenml' && !props.dealer_sso) {
                  if(enamelCategory && enamelCategory === "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'pc'){
                    window.location.replace(constructDynamicURL('PC'))
                  } else if(enamelCategory && enamelCategory !== "PAINTING CONTRACTORS" && pathParams[1].toLowerCase() !== 'ptr') {
                    window.location.replace(constructDynamicURL('PTR'))
                  }
                }

                const redemptionResponse = await redemption() 
                
                const response = redemptionResponse.data.data
                if(response.redeemable === false){
                  setPaymentStatus('NOT POSSIBLE')
                  setPaymentMessage("You are a " + response.user_type)
                  setIsSuccess(true)
                  setCanRedeem(false)
                }
                else{
                  setIsOtpVerified(true)
                  if(response.user_type !== "NEW USER"){
                    setIsNewUser(false)
                    setNewUser(false)
                    setMembershipID(response.membership_id)
                    if (pathParams[2].toLowerCase() !== 'dfwpputty' && (response.membership_id && pathParams[1].toLowerCase() == 'pc' && !props.dealer_sso)) {
                      await checkSpecialBonus(response.membership_id)
                    }
                  }

                  if(response.redemption_options.POINTS === true){
                    setRedeemable(true)
                  }
                  const factor = response.conversion
                  const bonusFactor = response.bonus
                  setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                  setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
                }

            }
            else{
              const errMessageOTP = fetchResponse.response.data;
                // setOtpMessage('Invalid OTP')
                setOtpMessage(errMessageOTP.message.otp)
            }
          }
          } catch (e) {
            setIsVerified(false)
            setMsgPh('Something went wrong')
          } 
          setLoading(false)
        }
    };


  const handleToUpdateOTPdealer = async (arg: any) => {
    if (arg === 'GoBack') {
      setIsVerified(false)
    }
    else {
      if (!localStorage.getItem("IS_LOGIN")) {
        setLoading(true)


        if (newUser === false) {
          setIsNewUser(false)
        }
      }
      try {
        if (localStorage.getItem("IS_LOGIN") === "yes" && localStorage.getItem("phone_number")) {      //
        }
        else {
          const fetchResponse = await getTokenPair(phoneNodealer, arg)
          const status = fetchResponse.status
          if (status === 200) {
            const headers = fetchResponse.headers
            localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
            localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])
            localStorage.setItem('isDealerVerified', 'yes');
            setisDealerVerifed(false);
            setIsVerified(false);
            getDealerName();
          }
          else {
            const errMessageOTP = fetchResponse.response.data;
            setOtpMessage(errMessageOTP.message.otp)
          }
        }
      } catch (e) {
        setIsVerified(false)
        setMsgPh('Something went wrong')
      }
      setLoading(false)
    }
  };

  const getDealerName = async () => {
    setLoading(true)
    return axios
      .get(
        `${HOST}apis/v.1.0/lhccinstantrewards/dealer-info/?phone_number=${localStorage.getItem("phone_number")}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')       
          }
        }
      )
      .then((res: any) => {
        // console.log(res, "refhvbejsbfcjwbecjhweb");
        localStorage.setItem('dealer_name', res.data.dealername_c);
        // setSDKToken(res.data.sdk_token);
        // clearInterval(interval1);
        // setLoading(false);
        return res;
      })
  }

    const handleToUpdateAddDetails = (arg: any) => {
      setLoading(true)
        if(arg === 'GoBack'){
            resetAll(true)
        }
        else{
          axios
            .post(
              `${HOST}${API}register-user/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ?
                localStorage.getItem("isDealerVerified") === "yes" ?
                  localStorage.getItem("contractor_phone_number")
                  : localStorage.getItem("phone_number") : phoneNo,
                name: arg.name,
                endusercategory_c: arg.endusercategory_c, 
                profession: arg.profession,
                pincode: arg.pincode,
                user: "BST",
                alternate_mobile_no: arg.alternatePhone
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
                if(res.data.data.data.resultCode === 0){
                  setMembershipID(res.data.data.data.membershipId)
                  setIsNewUser(false)
                  localStorage.setItem("NewUser", "NewUser")
                }
                else{
                  setIsVerified(false)
                  setIsOtpVerified(false)
                  setInvalidCoupon(true)
                  setMsgPh('something went wrong')
                }
                if(res.status === 401 && res.messages.message === refresh_error_msg && count === 0){
                  refresh_access_token(res)
                  handleToUpdateAddDetails(arg)
                  count += 1
                }
                  setLoading(false)
              })
            .catch((err: any) => {
                count = 0
                setIsVerified(false)
                setIsOtpVerified(false)
                setMsgPh('Something went wrong')
                setLoading(false)
            });
          }
    }


    const handleToUpdateStatusDealer = () => {
      setTransactionLoading(true)
      setLoading(true)

      axios //to get list of transactions
        .get(
          `${HOST}${API}hcc-rewards/transaction-details/${userType}/${localStorage.getItem("phone_number")}/?limit=10`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              handleToUpdateAmount();
              setTransactions(res.data.results)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
      
        // setPaymentMessage(message)
        // setPaymentStatus(arg)
        // if(arg === "FAILURE"){
        // }
        setIsSuccess(true)
        setLoading(false)
    }


    const handleToUpdateAmount = () => {
      setTransactionLoading(true)
      setLoading(true)
      axios //to get list of transactions
        .get(
          `${HOST}${API}hcc-rewards/total-redeemption/${userType}/${localStorage.getItem("phone_number")}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              console.log(res.data.total_redeem_amount, "sjchbwjbhechjwe");
              setTransactionsAmmount(res.data.total_redeem_amount)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });

        setIsSuccess(true)
        setLoading(false)
    }


    
    const handleToUpdateStatus = (arg: any, message:any, orderId: string, id: string) => {
      // setLoading(true)
      // setOrderID(orderId)      
      //   setPaymentMessage(message)
      //   setPaymentStatus(arg)
      //   if(arg === "FAILURE"){
      //   }
      //   setIsSuccess(true)
      //   setLoading(false)
      setTransactionLoading(true)
      setLoading(true)
      setOrderID(orderId)
      setRazorID(id)
      if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}transaction-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setTransactions(res.data)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
      }
        setPaymentMessage(message)
        setPaymentStatus(arg)
        if(arg === "FAILURE"){
        }
        setIsSuccess(true)
        setLoading(false)
    }

    const handleToGetPreviousBankDetails = async() => {
      setLoading(true)
      // if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}banking-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setPreviousBankDetails(res.data);
              if(res.data.length >0) {
                setPreviousBankDetailsFlag(true);
              }
              setLoading(false)
            }
          })
        .catch((err: any) => {
          setLoading(false)
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
        });
      // }
    }

    const previouslyAddedBankTransaction = (arg:any, type: any) => {
      setPreviousBankUUID([arg, type]);
      setBankDetailsSet(true);
    }

    const removePreiouslyAddedBanks = async(arg:any) => {
      setLoading(true)
      return axios
          .delete(
            `${HOST}${API}banking-details/`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              },
              params: {
                user_type: userType,
                bank_uuid: arg
              },
            },
          )
          .then((res: any) => {
            setLoading(false)
            handleToGetPreviousBankDetails();
            return res;
          })
          .catch((err: any) => {
            setLoading(false)
            return err;
          });
    }


    
// For future use
//     const getOnfidoStatus = () => {
//       // setLoading(true);
//       return axios
//       .get(
//           `${HOST}apis/v.1.0/onfido/get-onfido-status/?membership_no=${membershipID}`,
//           {
//               headers: {
//                   'Content-Type': 'application/json',
//                   'X-application-token': '8a16f58c77d04ff49ad9998aba16462258add7ea__token__eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbmFtZSI6InBpbGxsaWxiZWprbGV0a2Vwcm9kIiwidHlwZSI6ImZyb250d2Vwcm9kIn0.Pp5DUQJxYIzuL7IexPDf-EGutokUbl8mZrK_o5rvfCA'
//               }
//           }
//       )
//       .then((res: any) => {

//           setKycStatus(res.data.onfido_kyc_status_c);
//           setKycStatusAttempt(res.data.onfido_kyc_attempt_c);

//           if(paymentType != "bank"){
//             if(res.data.onfido_kyc_status_c == "Pending"){
//             }
//             else if(res.data.onfido_kyc_status_c == "Rejected" && (res.data.onfido_kyc_attempt_c == 1)){
//               alert('Your Kyc is rejected, Please try Again!');
//               setLoading(false);
//               clearInterval(interval);
//               setIsOnfidoPage(true);
//             }
//             else if(res.data.onfido_kyc_status_c == "Rejected" && (res.data.onfido_kyc_attempt_c == 2 || res.data.onfido_kyc_attempt_c > 2)){
//               setRejectKYC(true);
//               setLoading(false);
//               clearInterval(interval);
//             }else if(res.data.onfido_kyc_status_c == "Approved") {
//               setLoading(false);
//               clearInterval(interval);
//               setIsOnfidoPage(false);
//             }
//           }else{
//             if(res.data.onfido_kyc_status_c == "Pending"){
//             }
//             else if(res.data.onfido_kyc_status_c == "Rejected" && (res.data.onfido_kyc_attempt_c == 1)){              
//               alert('Your Kyc is rejected, Please try Again!');
//               setLoading(false);
//               clearInterval(interval);
//               setIsOnfidoPage(true);
//             }else if(res.data.onfido_kyc_status_c == "Rejected" && (res.data.onfido_kyc_attempt_c == 2 || res.data.onfido_kyc_attempt_c > 2)){
//               setRejectKYC(true);
//               setLoading(false);
//               clearInterval(interval);
//             }else if(res.data.onfido_kyc_status_c == "Approved") {
//               clearInterval(interval);
//               setIsOnfidoPage(false);
//             }
//           }

//       })
//       .catch((err: any) => {
//           // alert(err)
//           return err;
//       });
      
//     }



//     const getOnfidoStatus1 = () => {
//       setLoading(true);
//       return axios
//       .get(
//           `${HOST}apis/v.1.0/onfido/get-onfido-status/?membership_no=${membershipID}`,
//           {
//               headers: {
//                   'Content-Type': 'application/json',
//                   'X-application-token': '8a16f58c77d04ff49ad9998aba16462258add7ea__token__eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbmFtZSI6InBpbGxsaWxiZWprbGV0a2Vwcm9kIiwidHlwZSI6ImZyb250d2Vwcm9kIn0.Pp5DUQJxYIzuL7IexPDf-EGutokUbl8mZrK_o5rvfCA'
//               }
//           }
//       )
//       .then((res: any) => {

//           setKycStatus(res.data.onfido_kyc_status_c);
//           setKycStatusAttempt(res.data.onfido_kyc_attempt_c);
//           if(res.data.onfido_kyc_status_c == "Pending"){
//           }
//           else if(res.data.onfido_kyc_status_c == "Rejected" && (res.data.onfido_kyc_attempt_c == 2 || res.data.onfido_kyc_attempt_c > 2)){
//             setRejectKYC(true);
//             setLoading(false);
//             clearInterval(interval);
//           }else if(res.data.onfido_kyc_status_c == "Approved") {
//             setLoading(false);
//             clearInterval(interval);
//           }

//       })
//       .catch((err: any) => {
//           // alert(err)
//           return err;
//       });
      
//     }

    

//     const isOnfido = () => {
//       onfidoTag = Onfido.init({
//         options: {
//             forceCrossDevice: false
//         },
//         useModal: true,
//         isModalOpen: true,
//         onModalRequestClose: function () {
//             onfidoTag.setOptions({ isModalOpen: false })
//         },
//         hideContinueOnPhone: true,
//         token: SDKToken,
//         steps: [
//             {
//                 "type": "document",
//                 "options": {
//                     "documentTypes": {
//                         "national_identity_card": {
//                             "country": "IND"
//                         },
//                     }
//                 }
//             },
//             "face"
//         ],
//         onComplete: async function (res: any) {
//             try {
//                 const Params = {
//                     onfido_document_front_id_c: res.document_front.id,
//                     ...(res.document_back !== undefined && res.document_back.id
//                         ? { onfido_document_back_id_c: res.document_back.id }
//                         : {}),
//                     onfid_face_id_c: res.face.id,
//                     membership_no: membershipID,
//                 };

//                 return axios
//                     .post(
//                         `${HOST}apis/v.1.0/onfido/submit-document/`, Params,
//                         {
//                             headers: {
//                                 'Content-Type': 'application/json',
//                                 'X-application-token':
//                                 '8a16f58c77d04ff49ad9998aba16462258add7ea__token__eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbmFtZSI6InBpbGxsaWxiZWprbGV0a2Vwcm9kIiwidHlwZSI6ImZyb250d2Vwcm9kIn0.Pp5DUQJxYIzuL7IexPDf-EGutokUbl8mZrK_o5rvfCA'
//                             }
//                         }
//                     )
//                     .then((res: any) => {
//                         onfidoTag.setOptions({ isModalOpen: false })
//                         if(paymentType != "bank"){
//                           // setIsOnfidoPage(false);
//                           setLoading(true);
//                         }
//                          interval = setInterval(() => {
//                           getOnfidoStatus();
//                         }, 2000);
                        
//                         return res;
//                     })
//                     .catch((err: any) => {
//                         // alert(err)
//                         return err;
//                     });
                    
                    
//             } catch (error) {
//                 alert('Error :: Submit KYC details --');
//             } finally {
//             }
//         },

//     })
//     Onfido.config = {
//         hideContinueOnPhone: true,
//     };
//     // handlestatus()
// }
  

    const handleToProceedPayment = async(arg: any, amount:any, type:any, bonusAmount:any) => {
      const path = window.location.pathname;
      const pathParams = path.split('/');

      if (membershipID && (pathParams[1].toLowerCase() == 'ptr' || pathParams[1].toLowerCase() == 'pc')) {
          await checKYCStatus();
          await documentIdfyStatus(membershipID, '', true);
      }

      setLoading(true)
      setPreviousBankType(arg)
        if(arg === 'GoBack'){
            if(newUser === false){
              resetAll(true)
            }
            else{
              setIsNewUser(true)
            }
        } 
        // logic to convert credit to inr and points
        else{


        if (pathParams[1].toLowerCase() == "pc" && KYCRequired == true && KycStatus != "Approved" && !localStorage.getItem("isDealerVerified")) {
          
          setAmount(amount)
          setBonusAmount(bonusAmount)
          setIsProceeded(true)
          if (arg === 'paytm') {
            setPaymentType('paytm')
            setLoading(false)
          }
          else if (arg === 'bankAccount') {
            if (type === "AddNew") {
              setPreviousBankDetailsFlag(false);
              setLoading(false)
            }
            if (type !== "AddNew") {
              await handleToGetPreviousBankDetails();
            }
            setPaymentType('bank')
          }
          else if (arg === 'fccPoints') {
            setPaymentType('points')
            setLoading(false)
          }
          setIsOnfidoPage(true);
          // setLoading(false);
        } else {
          setAmount(amount)
          setBonusAmount(bonusAmount)
          setIsProceeded(true)
          if (arg === 'paytm') {
            setPaymentType('paytm')
            setLoading(false)
          }
          else if (arg === 'bankAccount') {
            if (type === "AddNew") {
              setPreviousBankDetailsFlag(false);
              setLoading(false)
            }
            if (type !== "AddNew") {
              await handleToGetPreviousBankDetails();
            }
            setPaymentType('bank')
          }
          else if (arg === 'fccPoints') {
            setPaymentType('points')
            setLoading(false)
          }
        }
      }
    }

    const handleToUpdateBankDetails = (arg: any) => {
      
      
          if(KycStatus == "Pending"){
            alert("Kyc verification is in process, Please try again to click Save Account details Button! ");
            return;
          }
          else if(KycStatus == "Rejected" && (KycStatusAttempt == 1)){
            alert('Your Kyc is rejected, Please try Again!');
            setLoading(false);
            setIsOnfidoPage(false);
          }
          else if(KycStatus == "Rejected" && (KycStatusAttempt == 2 || KycStatusAttempt > 2)){
            setRejectKYC(true);
            setLoading(false);
          }else if(KycStatus == "Approved") {
            setLoading(false);
            setIsOnfidoPage(false);
          }
          
          setLoading(true);

        if(arg === 'GoBack'){
            setIsProceeded(false)
        }
        else{ //api to send bank details locally
            
            setAccNo(arg.accNo)
            setIfsc(arg.ifsc)
            axios
            .post(
              `${HOST}${API}banking-details/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo, 
                account_number: arg.accNo,
                ifsc_code: arg.ifsc,
                bank_name: arg.bankName === 'Others' ? arg.otherBankName : arg.bankName,
                user_type: userType 
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
              if(res.data.message === 'Maximum accounts added' || res.data.message === 'IFSC Code invalid' || res.data.message === 'Record with same account number exists' || res.data.message === 'Error occurred while Saving Bank Account Details. Please Enter another bank account number and continue.'){
                setBankMsg(res.data.message)
              }
              else{
                setBankDetailsSet(true)
              }
              setLoading(false)
              })
            .catch((err: any) => {
              if(err.status === 401 && err.messages.message === refresh_error_msg && count === 0){
                refresh_access_token(err)
                handleToUpdateAddDetails(arg)
                count += 1
              }
              else{
                count = 0
                resetAll(true)
                setMsgPh('something went wrong')
              }
              setLoading(false)
            });    
        } 
        // setLoading(false)
    }

    const handleToUpdateSuccess = (arg: any) => {
      if(arg === 'GoBack'){
        resetAll(false)
    }
    let myVar:any;
    if(paymentType === "bank") {
      const timeout = async (i:any) =>{
        // setLoading(true)
        myVar = await new Promise((resolve)=> setTimeout(function(){ 
          // if(i === 6) {
          //   // setPaymentStatus("FAILURE")
          //   clearTimeout(myVar);
          //   return;
          // }
          // else 
          if(localStorage.getItem("tran_status") === "FAILURE") {
            clearTimeout(myVar);
            return;
          }
          else if(localStorage.getItem("tran_status") === "SUCCESS") {
            clearTimeout(myVar);
            return;
          }
          axios
          .post(
            `${HOST}${API}get-transaction-status/`, 
            {
              order_id: orderID,
              payment_type: paymentType,
              userType: userType,
              razor_transaction_id: razorID
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')       
              }
            }
          )
          .then((res: any) => {
              let status = res.data.response.status === "processed" || res.data.response.status === "SUCCESS" ? "SUCCESS" : 
              res.data.response.status === "queued" || res.data.response.status === "pending" || res.data.response.status === "processing" || res.data.response.status === "APPROVAL_PENDING" || res.data.response.status === "PENDING" || res.data.response.status === "QUEUED" || res.data.response.status === "RECEIVED" ? "PENDING" :
              "FAILURE";
              let statusMessage = res.data.response.statusMessage
              setFailUnbind(status);
              if(status !== "PENDING"){
                localStorage.setItem("tran_status", status)
                setPaymentStatus(status)
                setPaymentMessage(statusMessage)
                setConfirmedPayStatus(true)
              }
            })
          .catch((err: any) => {
          });
          if(i === 3) {
            clearTimeout(myVar);
            return;
          }
          resolve(i);
        }, 10000*i));
          // setLoading(false)
      }
      if(arg === "PENDING"){
        if(countCheck === true) {
          for(let i=1; i<=3; i++){
            timeout(i)
          }
        }
        setCount(false);
      }
      if(failUnbind === "SUCCESS"){
        return;
      }
      if(failUnbind === "FAILURE"){
        return;
      }
    }
    else {
    const timeout = async (i:any) =>{
      // setLoading(true)
      myVar = await new Promise((resolve)=> setTimeout(function(){ 
        // if(i === 6) {
        //   // setPaymentStatus("FAILURE")
        //   clearTimeout(myVar);
        //   return;
        // }
        // else 
        if(localStorage.getItem("tran_status") === "FAILURE") {
          clearTimeout(myVar);
          return;
        }
        else if(localStorage.getItem("tran_status") === "SUCCESS") {
          clearTimeout(myVar);
          return;
        }
        axios
        .post(
          `${HOST}${API}get-transaction-status/`, 
          {
            order_id: orderID,
            payment_type: paymentType,
            userType: userType
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            let status = res.data.response.status
            let statusMessage = res.data.response.statusMessage
            setFailUnbind(status);
            if(status !== "PENDING"){
              localStorage.setItem("tran_status", status)
              setPaymentStatus(status)
              setPaymentMessage(statusMessage)
              setConfirmedPayStatus(true)
            }
          })
        .catch((err: any) => {
        });
        if(i === 3) {
          clearTimeout(myVar);
          return;
        }
        resolve(i);
      }, 10000*i));
        // setLoading(false)
    }
    if(arg === "PENDING"){
      if(countCheck === true) {
        for(let i=1; i<=3; i++){
          timeout(i)
        }
      }
      setCount(false);
    }
    if(failUnbind === "SUCCESS"){
      return;
    }
    if(failUnbind === "FAILURE"){
      return;
    }
  }
}

const checkSpecialBonus = async(membershipID:any) => {
  setLoading(true)
  axios 
    .get(
      `${HOST}${API}haisha-contractor/${membershipID}/eligible-special-bonus/`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('x-access-token')       
        }
      }
    )
    .then((res: any) => {
        if(res.status === 200){
          setLoading(false)
          setSpecialBonus(res.data.is_eligible_special_bonus)
          if(res.data.is_eligible_special_bonus) {
            setShowTranDet(true);
          }
        }
      })
    .catch((err: any) => {
      setLoading(false)
    });
}

    const handleLogout = () => {
      setIsVerified(true)
      window.location.reload();
      localStorage.clear();
    }

    // for IDFY
    const getDocFile = (file: any, uploadFlag: any) => {
      setGetFile(file);
      setDocUploadFlag(uploadFlag)
    }

    const getSelfieFile = (file: any) => {
      setSelfieFile(file);
    }
  
    const uploadDocumentIdfy = async () => {
      setDocUploadLoading(true)
      setLoading(true)
      let formdata = new FormData();
      formdata.append("img", getFile);
      formdata.append("membership_no", membershipID);
      return axios
        .post(
          `${HOST}apis/v.1.0/idfy/check-document/`,
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              'Authorization': localStorage.getItem('x-access-token')
            },
          }
        )
        .then(async (res: any) => {
          console.log(res.data, "res")
          const data = res.data;
          setKycDocStatus(data)
          if(data.status === true) {
            setIsSelfiePage(true);
          }
          // const docidfyStatus = await documentIdfyStatus(membershipID);
          // const idfyData = docidfyStatus.data
          // setDocUploadLoading(false)
          // setLoading(false)
          // // set interval if kyc status is pending
          // const timeout = async (i: any) => {
          //   setLoading(true);
          //   // let myVar: any;
          //   interval = await new Promise((resolve) => setTimeout(function () {
          //     if (localStorage.getItem("kyc_status") === "Rejected") {
          //       setLoading(false);
          //       clearTimeout(interval);
          //       return;
          //     }
          //     else if (localStorage.getItem("kyc_status") === "Approved") {
          //       setLoading(false);
          //       clearTimeout(interval);
          //       return;
          //     }
          //     documentIdfyStatus(membershipID, "timer");
          //     if (i === 3) {
          //       setLoading(false);
          //       clearTimeout(interval);
          //       return;
          //     }
          //     resolve(i);
          //   }, 10000 * i));
          // }
          // if (idfyData.status === "Pending") {
          //   setLoading(false);
          //   if (idfyCountCheck === true) {
          //     for (let i = 1; i <= 3; i++) {
          //       timeout(i)
          //     }
          //   }
          //   setIdfyCount(false);
          // }//end here
  
          // if (idfyData.status === "Approved") {
          //   setIsOnfidoPage(false);
          //   setKycMessageVerified("Yes")
          // }
          // setIsOnfidoPage(false) //added for transaction after idfy

          setDocUploadLoading(false)
          setLoading(false)
          setFaceLiveMessage('')
          return res
        })
        .catch((error: any) => {
          setDocUploadLoading(false)
          setLoading(false)
          setFaceLiveMessage('')
          return error
        });
    }
  
    const documentIdfyStatus = async (arg: any, timer?: any, docUploadLoadingFlag?: any) => {
      // if (!timer) {
      if(docUploadLoadingFlag === true) {
        setDocUploadLoading(false)
      } else {
        setDocUploadLoading(true)
      }
      setLoading(true)
      // }
      return axios
        .get(
          `${HOST}apis/v.1.0/idfy/check-status/?membership_no=${arg}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then((res: any) => {
          const data = res.data;
          setIdfyDocData(data)
          if (data.status === "Pending") {
            setIdfyTranStatus("Kyc verification is in process, Please try again after sometime!")
            setIsOnfidoPage(true)
            setIsSelfiePage(false);
          } else if (data.status === "Rejected" && (data.attempt === 2 || data.attempt > 2)) {
            setRejectKYC(true);
            clearTimeout(interval);
            setIsOnfidoPage(true)
            setLoading(false);
            setIsSelfiePage(false);
            localStorage.setItem("kyc_status", data.status)
          } else if (data.status === "Rejected" && (data.attempt < 3)) {
            setIdfyTranStatus('Your Kyc is rejected, Please try Again!')
            clearTimeout(interval);
            setLoading(false);
            setIsOnfidoPage(true);
            setIsSelfiePage(false);
            localStorage.setItem("kyc_status", data.status)
          } else if (data.status === "Approved") {
            clearTimeout(interval);
            setIsOnfidoPage(false);
            setIsSelfiePage(false);
            setLoading(false);
            localStorage.setItem("kyc_status", data.status)
          }
  
          setKycStatus(data.status)
          setKycStatusAttempt(data.attempt)
          setDocUploadLoading(false)
          // setLoading(false)
          return res;
        })
        .catch((error: any) => {
          setDocUploadLoading(false)
          setLoading(false)
          return error
        });
    }

    const faceCompare = async() => {
      localStorage.removeItem("kyc_status");
      setDocUploadLoading(true)
      setLoading(true)
      let formdata = new FormData();
      formdata.append("img", getSelfie);
      formdata.append("membership_no", membershipID);
      return axios
        .post(
          `${HOST}apis/v.1.0/idfy/face-compare-live/`, formdata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then(async(res: any) => {
          const data = res.data;
          setDocUploadLoading(false)
          setLoading(false)
          if(data.status === "Rejected") {
            setIsOnfidoPage(true);
            setIsSelfiePage(false);
            await documentIdfyStatus(membershipID);
            return;
          } else if (data.status === "Approved") {
            setIsSelfiePage(false);
            setIsOnfidoPage(false)
          } else if (data.status === "Pending") {
          const docidfyStatus = await documentIdfyStatus(membershipID);
          const idfyData = docidfyStatus.data
          setDocUploadLoading(false)
          setLoading(false)
          // set interval if kyc status is pending
          const timeout = async (i: any) => {
            setLoading(true);
            // let myVar: any;
            interval = await new Promise((resolve) => setTimeout(function () {
              if (localStorage.getItem("kyc_status") === "Rejected") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              else if (localStorage.getItem("kyc_status") === "Approved") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              documentIdfyStatus(membershipID, "timer");
              if (i === 3) {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              resolve(i);
            }, 10000 * i));
          }
          if (idfyData.status === "Pending") {
            setLoading(false);
            if (idfyCountCheck === true) {
              for (let i = 1; i <= 3; i++) {
                timeout(i)
              }
            }
            setIdfyCount(false);
          }//end here
  
          if (idfyData.status === "Approved") {
            setIsOnfidoPage(false);
            setIsSelfiePage(false);
            setKycMessageVerified("Yes")
          }
        }
          // setIsOnfidoPage(false) //added for transaction after idfy
          // ---
          return res;
        })
        .catch(async(error: any) => {
          const errRes = error.response;
          setSelfieDocStatus(errRes.data)
          // Added for face liveness message
          if (errRes.status === 400) {
            if (errRes.data.status === "Rejected") {
              setFaceLiveMessage(errRes.data.message)
            }
          }
          if (errRes.data.status === false) {
            setIsOnfidoPage(true);
            setIsSelfiePage(false);
            await checKYCStatus();
            await documentIdfyStatus(membershipID);
          }
          setDocUploadLoading(false)
          setLoading(false)
          return error
        });
    }
  
    const documentTransactionBasedStatus = () => {
      setLoading(true)
      return axios
        .get(
          // `${HOST}apis/v.1.0/fevikwik/check-transaction-based-kyc/${membershipID}/`,
          `${HOST}apis/v.1.0/haisha-contractor/${localStorage.getItem("phone_number")}/check-kyc-required/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then((res: any) => {
          const data = res.data;
          setLoading(false)
          setSkipStatus(data.is_kyc_required)
          setIsOnfidoPage(true);
          return res;
        })
        .catch((error: any) => {
          setLoading(false)
          return error
        });
    }
    // end here


  let isEndUserCategory = localStorage.getItem("isEndUserCategory") &&
    localStorage.getItem("division") == "BST"
    ?
    localStorage.getItem("isEndUserCategory") == 'PAINTING CONTRACTORS' ? 'pc' : 'ptr' :
    null;

    
        return (
          (pathParams[2].toLowerCase() == 'puenml' ||  isEndUserCategory == null ||
          pathParams[1].toLowerCase() == isEndUserCategory) ? 
          RejectKYC ?
          <ErrorMessage addClass='app3' />
          :
          LoginMsg ?
          <ErrorMessage addClass='app2' />
            :
            <div className='home popup_logout'>
              
                {
                    (loading) &&
                    <CircularProgress />
                }

                {
                    !loading && loadingRedeem &&
                    <CircularProgress />
                }

                {
                  docUploadLoading &&
                  <p className="docUploadWaitLoader">Please wait!</p>
                }

                {localStorage.getItem("IS_LOGIN") === "yes" &&
                <div className="logout_btn_paytm button">
                <button className="logout_btn" onClick={handleLogout}><PowerSettingsNewIcon /> Logout</button>
              </div>
                }

                  {/* For future use
                   {localStorage.getItem("IS_LOGIN") === "yes" && !loading && pathParams[1].toLowerCase() == 'ptr' &&
                    isOnfidoPage ?
                    skipStatus ?
                      <Typography style={{ color: "red" }}>The kyc is mandatory after 2 transactions!</Typography> :
                      <div className="logout_btn_paytm2 button">
                        <button className="logout_btn" disabled={skipStatus ? true : false} onClick={() => (setIsOnfidoPage(false), setIsSelfiePage(false))}>
                          Skip kyc verification</button>
                      </div>
                    :
                    null
                  } */}

                {
                  couponValid && localStorage.getItem("IS_LOGIN") === "yes" && !isDealerVerifed &&
                  <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }
                { 
                    !isVerified && !loading && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && !isDealerVerifed &&
                    !localStorage.getItem("IS_LOGIN") && !isDashboardFlag &&
                    <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }

                {
                    !isOtpVerified && isVerified && !loading && canRedeem && !localStorage.getItem("IS_LOGIN") && !isDealerVerifed &&
                    <VerifyOtp handleToUpdateOtp={handleToUpdateOTP} msg={otpMessage} />
                }
                {
                    !isOtpVerified && isVerified && !loading && canRedeem && !localStorage.getItem("IS_LOGIN") && isDealerVerifed && 
                    <VerifyOtpDealer handleToUpdateOtp={handleToUpdateOTPdealer} msg={otpMessage} />
                }

                {
                    isOtpVerified && isNewUser && !loading && !loadingRedeem && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && paymentStatus !== 'NOT POSSIBLE' &&
                    <CustomerDetails division={userType} handleToUpdateAdded={handleToUpdateAddDetails}/>
                }

                {
                  !isNewUser && !isProceeded && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid && !loading && !isDashboardFlag && specialBonus && showTranDet &&
                  <HaishaBonus setShowTranDet={setShowTranDet} />
                }
                
                {
                    !isNewUser && !isProceeded && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid && !loading && !isDashboardFlag && !showTranDet &&
                    <TransactionDetails conversions={conversions} redeemPoints={redeemable} amount={amount} 
                    userType={userType} handleToProceed={handleToProceedPayment} bonusPoint={bonusPoint} specialBonus={specialBonus} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='paytm' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="wallet" phoneNumber={phoneNo} amount={amount} coupon={pathParams[1].toLowerCase() === "roofsealclassic" ? newCouponCode : couponCode} user={userType} 
                    membershipID={membershipID} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && !previousBankDetailsFlag && !isOnfidoPage &&
                    <BankDetails bankMsg={bankMsg} handleToUpdatePayment={handleToUpdateBankDetails}/> 
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && previousBankDetailsFlag && !isOnfidoPage && 
                    <PreviousBankDetails 
                    handleToProceed={handleToProceedPayment} previousBankDetails={previousBankDetails} amount={amount} 
                    prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                    removePreiouslyAddedBanks={removePreiouslyAddedBanks} bonusAmount={bonusAmount} />
                }

                {
                    bankDetailsSet && !isSuccess && paymentType==='bank' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="bank" phoneNumber={phoneNo} amount={amount} coupon={pathParams[1].toLowerCase() === "roofsealclassic" ? newCouponCode : couponCode} user={userType} 
                    membershipID={membershipID} accNo={accNo} ifsc={ifsc} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='points' && !loading && !couponValid && !isOnfidoPage && 
                    <Payouts type="points" user={userType} membershipID={membershipID} coupon={pathParams[1].toLowerCase() === "roofsealclassic" ? newCouponCode : couponCode} phoneNumber={phoneNo} 
                    amount={amount}  handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} />
                }

                {
                    isSuccess && !confirmedPayStatus && !loading && !couponValid &&  !isOnfidoPage && 
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} transactionsAmmount={transactionsAmmount}/>
                }

                {
                    isSuccess && confirmedPayStatus && !loading && !couponValid && !isOnfidoPage && 
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} transactionsAmmount={transactionsAmmount} />
                }

              {/* {
                    isOnfidoPage && !loading && !couponValid && pathParams[1].toLowerCase() !== 'ptr' &&
                    <OnfidoPage  
                    membershipID={membershipID}
                    isOnfidoVerify={isOnfido}
                     />
              } */}

              {
                isOnfidoPage && !isSelfiePage &&
                !loading && !couponValid && 
                <OnfidoPageptr
                  membershipID={membershipID}
                  uploadDocumentIdfy={uploadDocumentIdfy}
                  docUploadLoading={docUploadLoading}
                  getDocFile={getDocFile}
                  isDashboardFlag={isDashboardFlag}
                  idfyDocData={idfyDocData}
                  idfyTranStatus={idfyTranStatus}
                  kycStatusFlag={KycStatus}
                  KycStatusAttempt={KycStatusAttempt}
                  setKycStatus={setKycStatus}
                  kycDocStatus={kycDocStatus}
                  selfieDocStatus={selfieDocStatus}
                />
              }

              {
                isSelfiePage && !loading && !couponValid && 
                <ImageUploadPage setIsOnfidoPage={setIsOnfidoPage} membershipID={membershipID}
                  faceCompare={faceCompare} getSelfieFile={getSelfieFile} faceLiveMessage={faceLiveMessage}
                  idfyDocData={idfyDocData} />
              }

                <Footer />

            </div>    
            :
            <ErrorMessage addClass="app2" />         
        )
    }

export default Main